<div class="ribbon-group">
    <div class="ribbon-group-content">
      <div
        class="ribbon-button ribbon-button-big txui-state-disabled"
        id="ribbonTxDocs_SendToPortal"
        [ngClass]="{ 'txui-state-disabled': !letterheadExists }"
        (click)="onInsertLetterheadClicked()">
        <div class="ribbon-button-big-image-container">
          <img
            class="ribbon-button-big-image"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktZmlsZS1lYXJtYXJrLXJpY2h0ZXh0IiB2aWV3Qm94PSIwIDAgMTYgMTYiPgogIDxwYXRoIGQ9Ik0xNCA0LjVWMTRhMiAyIDAgMCAxLTIgMkg0YTIgMiAwIDAgMS0yLTJWMmEyIDIgMCAwIDEgMi0yaDUuNXptLTMgMEExLjUgMS41IDAgMCAxIDkuNSAzVjFINGExIDEgMCAwIDAtMSAxdjEyYTEgMSAwIDAgMCAxIDFoOGExIDEgMCAwIDAgMS0xVjQuNXoiLz4KICA8cGF0aCBkPSJNNC41IDEyLjVBLjUuNSAwIDAgMSA1IDEyaDNhLjUuNSAwIDAgMSAwIDFINWEuNS41IDAgMCAxLS41LS41bTAtMkEuNS41IDAgMCAxIDUgMTBoNmEuNS41IDAgMCAxIDAgMUg1YS41LjUgMCAwIDEtLjUtLjVtMS42MzktMy43MDggMS4zMy44ODYgMS44NTQtMS44NTVhLjI1LjI1IDAgMCAxIC4yODktLjA0N2wxLjg4OC45NzRWOC41YS41LjUgMCAwIDEtLjUuNUg1YS41LjUgMCAwIDEtLjUtLjVWOHMxLjU0LTEuMjc0IDEuNjM5LTEuMjA4TTYuMjUgNmEuNzUuNzUgMCAxIDAgMC0xLjUuNzUuNzUgMCAwIDAgMCAxLjUiLz4KPC9zdmc+"
            style="height: 32px; width: 32px" />
        </div>
        <div class="ribbon-button-big-label-container">
          <p class="ribbon-button-label">
            <span class="ribbon-button-label-text">
              Insert letterhead
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="ribbon-group-label-container">
      <p class="ribbon-group-label">Letterhead</p>
    </div>
  </div>
  